/**
 * How a business's WhatsApp number was connected — which BSP / Meta app ran
 * the signup. Drives billing (see OUR_BSP_SIGN_UP_TYPES) and which credit
 * line Attach Credit Line hooks up (see creditLine.ts).
 */
export enum SignUpType {
  CUSTOM = 'custom',
  EMBEDDED = 'embedded',
  KARIX = 'karix',
  HELTAR = 'heltar',
  FIRST_CONNECT = 'first_connect',
  TATA = 'tata',
  KALEYRA = 'kaleyra',
  VALUE_FIRST = 'value_first',
  V_CONNECT = 'v_connect',
  ROUTE_MOBILE = 'route_mobile',
  MASIV = 'masiv',
  ONEXTEL = 'onextel',
}
